import React, { useState, useEffect, useCallback } from "react"
import Delete from "@spectrum-icons/workflow/Delete"
import {
    AddAgentGroupConfigRec,
    EditAgentGroupConfigRec,
    getQueueList,
    getStatusList,
    getAllAttributeListAndValues,
    fetchInstance,
    getDefaultGroupsConfig,
    bulkGroupConfigUpdate,
    getAgentGroupHierarchy,
} from "../../../utilities/api/phoenix-api"
import {
    Button,
    Flex,
    Content,
    Heading,
    ActionButton,
    DialogTrigger,
    Dialog,
    Divider,
    TextField,
    Footer,
    View,
    ButtonGroup,
    Header,
    Checkbox,
    NumberField,
    Item,
    Picker,
    ComboBox,
    SearchField,
    Text,
    Well,
} from "@adobe/react-spectrum"
import Copy from "@spectrum-icons/workflow/Copy"
import Add from "@spectrum-icons/workflow/Add"
import Undo from "@spectrum-icons/workflow/Undo"
import "./style.css"
import { notify } from "../../../constants/constants"


function DynamicFieldForm(props) {
    const {hierarchyKeys} = props
    const configKeys = [
        {
            key: "queues_assigned",
            name: "Queues Assigned",
        },
        {
            key: "proficiency",
            name: "Proficiency",
        },
        {
            key: "routing_profile_concurrency",
            name: "Routing Profile Concurrency",
        },
        {
            key: "entitlement_roles",
            name: "Entitlement Roles",
        },
        {
            key: "aic_config",
            name: "AIC Config",
        },
        {
            key: "case_configuration",
            name: "Case Configuration",
        },
        {
            key: "agent_states",
            name: "Agent States",
        },
        {
            key: "business_attributes",
            name: "Business Attributes",
        },
        {
            key: "system_skill",
            name: "System Skill",
        },
        {
            key: "skill_group",
            name: "Skill Group",
        },
        {
            key: "crm",
            name: "CRM",
        },
        {
            key: "queue_selection",
            name: "Queue Selection",
        },
        {
            key: "allowed_conversation_media",
            name: "Allowed Conversation Media",
        },
        {
            key: "default_outbound_queue",
            name: "Default Outbound Queue",
        },
        {
            key: "after_call_work",
            name: "After Call Work",
        },
        {
            key: "agent_hierarchy",
            name: "Agent Hierarchy",
        },
    ]
    const sideArrayObject = { key: "", value: "" }
    const sideArray = [sideArrayObject]
    const [mainArray, setMainArray] = useState([sideArray])
    const [objectSelected, setObjectSelected] = useState(new Set([]))
    const [inputFields, setInputFields] = useState([
        {
            agent_group_name: "",
            config_key: "",
            config_values: [{ key: "", value: "" }],
            action: "add",
            group: [],
        },
    ])

    const [queueList, setQueueList] = useState([])
    const [statusList, setStatusList] = useState([])
    const [attributeList, setAttributeList] = useState([])
    const [attValues, setAttValues] = useState([])
    const [instances, setInstances] = useState()
    const [activeInstance, setActiveInstance] = useState(
        props?.editData?.selectedData || props?.defaultInstanceId
    )
    const [agentGroupHierarchy, setAgentGroupHierarchy] = useState([])
    const [localGroupList, setLocalGroupList] = useState([])
    const [configKey, setConfigKey] = useState("")
    const [searchQuery, setSearchQuery] = useState("")
    const [isLoading, setIsLoading] = useState(false)


    const channels = [
        {
            id: "chat",
            name: "chat",
        },
        {
            id: "voice",
            name: "voice",
        },
        {
            id: "task",
            name: "task",
        },
    ]

    const actionItems = [
        {
            id: "add",
            name: "Add",
        },
        {
            id: "remove",
            name: "Remove",
        },
        {
            id: "sync",
            name: "Sync",
        },
    ]

    function getAllInstance() {
        fetchInstance()
            .then((result) => {
                // console.log("result of instance ", result)
                setInstances(result)
            })
            .catch((err) => {
                console.log("Error in fetching instances ", err)
            })
    }

    useEffect(() => {
        getAllInstance()
        activeInstance &&
            getDefaultGroupsConfig()
                .then((res) => {
                    setQueueList(res[activeInstance])
                })
                .catch((err) => console.log("Error in getting queue List", err))
    }, [activeInstance])

    useEffect(() => {
        getStatusList()
            .then((res) => setStatusList(res))
            .catch((err) => console.log("Error in getting queue List", err))
    }, [])

    useEffect(() => {
        getAllAttributeListAndValues(props.userid)
            .then((resp) => {
                setAttributeList(resp[activeInstance])
            })
            .catch((err) => {
                console.log("error ", err)
            })
    }, [activeInstance])

    // const debouncedAgentGroupName = useDebounce(inputFields[0]?.agent_group_name, 500);
    useEffect(() => {
        if((inputFields[0]?.agent_group_name || selectedGroups.length > 0) && inputFields[0]?.config_key === "agent_hierarchy"){
            setIsLoading(true)
            getAgentGroupHierarchy(inputFields[0]?.agent_group_name)
            .then((resp) => {
                setAgentGroupHierarchy(resp)
            }).catch((err) => {
                console.log("error ", err)
            })
            .finally(() => {
                setIsLoading(false)
            })
        }
    }, [inputFields[0]?.config_key])

    const convertArrayToInput = (values = []) => {
        return values.length
            ? values?.map((value, index) => ({ id: index, name: value }))
            : []
    }

    const defaultDataFormats = {
        after_call_work: [{ key: "duration", value: "0" }],
        agent_states: [
            { key: "routable", value: "false" },
            { key: "state", value: "" },
        ],
        allowed_conversation_media: [
            { key: "voice", value: "false" },
            { key: "task", value: "false" },
            { key: "chat", value: "false" },
        ],
        business_attributes: [
            { key: "scope", value: "" },
            { key: "attribute_name", value: "" },
        ],
        crm: [{ key: "crm_type", value: "Enterprise" }],
        default_outbound_queue: [{ key: "queue_name", value: "" }],
        queues_assigned: [
            { key: "queue_name", value: "" },
            { key: "channel", value: "chat" },
            { key: "priority", value: "1" },
            { key: "delay", value: "0" },
        ],
        routing_profile_concurrency: [
            { key: "max_concurrency", value: "1" },
            { key: "cross_channel_allow", value: "false" },
            { key: "media", value: "chat" },
        ],
        proficiency: [
            { key: "attributeName", value: "" },
            { key: "attributeValue", value: "" },
            { key: "level", value: "1" },
        ],
        instance_config: [
            { key: "instance_alias", value: "" },
            { key: "instance_id", value: "" },
            { key: "region", value: "" },
        ],
        agent_hierarchy: [
            { key: hierarchyKeys.levelOne || "", value: "" },
            { key: hierarchyKeys.levelTwo || "", value: "" },
            { key: hierarchyKeys.levelThree || "", value: "" },
            { key: hierarchyKeys.levelFour || "", value: "" },
            { key: hierarchyKeys.levelFive || "", value: "" },
        ],
        default: [{ key: "", value: "" }],
    }

    const addNewKeyValuePair = (sideArrayIndex) => {
        mainArray[sideArrayIndex].push(sideArrayObject)
        setMainArray(() => [...mainArray])
    }

    const addNewobject = (name, value) => {
        if (name === "config_key") {
            switch (value) {
                case "after_call_work":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "agent_states":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "allowed_conversation_media":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "business_attributes":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "crm":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "default_outbound_queue":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "queues_assigned":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "routing_profile_concurrency":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "proficiency":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "instance_config":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                case "agent_hierarchy":
                    setMainArray([...mainArray, defaultDataFormats[value]])
                    break
                default:
                    const tempValue = [{ key: "", value: "" }]
                    setMainArray([...mainArray, tempValue])
            }
        }
    }

    const updateValue = (mainIndex, objectIndex, type, value, name, obj) => {
        if (name === "instance_alias") {
            setMainArray((prevMainArray) => {
                const instanceObj = instances.find(
                    (ele) => ele.instance_id === value
                )
                const newData = JSON.parse(JSON.stringify(prevMainArray))
                newData[mainIndex][objectIndex][type] =
                    instanceObj.instance_alias
                if (newData[mainIndex][objectIndex][type]) {
                    newData[mainIndex][1][type] = instanceObj.instance_id
                    newData[mainIndex][2][type] = instanceObj.region
                }
                return newData
            })
        } else if (name === "queues_assigned") {
            setMainArray((prevMainArray) => {
                const newData = JSON.parse(JSON.stringify(prevMainArray))
                newData[mainIndex][objectIndex][type] = value

                let channel = "voice"

                if (value) {
                    const lowercaseValue = value.toLowerCase()

                    if (lowercaseValue.endsWith("msg")) {
                        channel = "chat"
                    } else if (
                        lowercaseValue.endsWith("vm") ||
                        lowercaseValue.endsWith("case")
                    ) {
                        channel = "task"
                    } else if (lowercaseValue.endsWith("ph")) {
                        channel = "voice"
                        newData[mainIndex][objectIndex][type] = value
                        newData.splice(mainIndex + 1, 0, [
                            { key: "queue_name", value: value },
                            { key: "channel", value: "task" },
                            { key: "priority", value: "1" },
                            { key: "delay", value: "0" },
                        ])
                    }
                }

                const channelIndex = newData[mainIndex].findIndex(
                    (item) => item.key === "channel"
                )
                newData[mainIndex][channelIndex].value = channel
                // console.log({ newData })
                return newData
            })
        }else if (name === "agent_hierarchy") {
            setMainArray((prevMainArray) => {
                const newData = JSON.parse(JSON.stringify(prevMainArray))
                const oldValue = newData[mainIndex][objectIndex][type]

                if (oldValue !== value) {
                    newData[mainIndex][objectIndex][type] = value

                    const currentKey = newData[mainIndex][objectIndex].key
                    const fieldsToReset = {
                        [hierarchyKeys.levelOne]: [hierarchyKeys.levelTwo, hierarchyKeys.levelThree, hierarchyKeys.levelFour, hierarchyKeys.levelFive],
                        [hierarchyKeys.levelTwo]: [hierarchyKeys.levelThree, hierarchyKeys.levelFour, hierarchyKeys.levelFive],
                        [hierarchyKeys.levelThree]: [hierarchyKeys.levelFour, hierarchyKeys.levelFive],
                        [hierarchyKeys.levelFour]: [hierarchyKeys.levelFive]
                    }

                    if (fieldsToReset[currentKey]) {
                        fieldsToReset[currentKey].forEach(fieldToReset => {
                            const fieldIndex = newData[mainIndex].findIndex(item => item.key === fieldToReset)
                            if (fieldIndex !== -1) {
                                newData[mainIndex][fieldIndex].value = ""
                            }
                        })
                    }
                }

                return newData
            })
        } else {
            setMainArray((prevMainArray) => {
                const newData = JSON.parse(JSON.stringify(prevMainArray))
                newData[mainIndex][objectIndex][type] = value
                // console.log({ newData })
                return newData
            })
        }
    }

    const deleteKeyValuePair = (objIndex, keyIndex) => {
        const data = JSON.parse(JSON.stringify(mainArray))
        data[objIndex].splice(keyIndex, 1)
        setMainArray(() => [...data])
    }

    // const deleteObject = (objIndex) => {
    //     const data = JSON.parse(JSON.stringify(mainArray));
    //     data.splice(objIndex, 1);
    //     setMainArray(()=>[...data]);
    // }

    const cloneObject = (objIndex, obj) => {
        const newArray = [...mainArray]
        newArray.splice(objIndex + 1, 0, obj)
        setMainArray(newArray)
    }
    const checkMainValue = () => {
        const value = mainArray.map((ele) => {
            return ele
                .map((objectlist) => {
                    if (objectlist.key)
                        return { [objectlist.key]: objectlist.value }
                    else return null
                })
                .filter((ele) => ele !== null)
                .reduce(function (result, current) {
                    return Object.assign(result, current)
                }, {})
        })

        return value
    }

    useEffect(() => {
        if (props.editData) {
            if (!props.editData.group_name) {
                const tempObj = props.editData.config_values
                    .map((entry) => {
                        if (props.editData.config_key === "queues_assigned") {
                            if (!entry.hasOwnProperty("priority")) {
                                entry.priority = "1"
                            }
                            if (!entry.hasOwnProperty("delay")) {
                                entry.delay = "0"
                            }
                        }
                        const keyValues = Object.entries(entry)
                        return keyValues.map(([key, value]) => ({ key, value }))
                    })
                    .flat()
                const mappedData = props.editData.config_values.map((entry) => {
                    if (props.editData.config_key === "queues_assigned") {
                        return [
                            { key: "queue_name", value: entry.queue_name },
                            { key: "channel", value: entry.channel },
                            { key: "priority", value: entry.priority || "1" },
                            { key: "delay", value: entry.delay || "0" },
                        ]
                    }
                    if (props.editData.config_key === "agent_hierarchy") {
                        return [
                            { key: hierarchyKeys.levelOne, value: entry[hierarchyKeys.levelOne] },
                            { key: hierarchyKeys.levelTwo, value: entry[hierarchyKeys.levelTwo] },
                            { key: hierarchyKeys.levelThree, value: entry[hierarchyKeys.levelThree] },
                            { key: hierarchyKeys.levelFour, value: entry[hierarchyKeys.levelFour] },
                            { key: hierarchyKeys.levelFive, value: entry[hierarchyKeys.levelFive] },
                        ]
                    }
                    const keyValues = Object.entries(entry).sort()
                    return keyValues.map(([key, value]) => ({ key, value }))
                })
                setMainArray([...mappedData])
                setInputFields([
                    {
                        agent_group_name: props.editData.agent_group_name || "",
                        config_key: props.editData.config_key || "",
                        config_values: tempObj || [{ key: "", value: "" }],
                    },
                ])
            } else {
                setInputFields([
                    {
                        agent_group_name: props.editData.group_name || "",
                        config_key: "",
                        config_values: [{ key: "", value: "" }],
                    },
                ])
            }

            if (props.editData.selectedData) {
                setActiveInstance(props.editData.selectedData)
            }
            console.log(props)
        }
    }, [props.editData, hierarchyKeys])

    // const addFields = () => {
    //     const updatedFields = [...inputFields]
    //     const newInnerObj = { key: "", value: "" }
    //     updatedFields[0].config_values.push(newInnerObj)
    //     setInputFields(updatedFields)
    // }

    // const deleteFields = (index) => {
    //     const updatedFields = [...inputFields]
    //     updatedFields[0].config_values = updatedFields[0].config_values.filter(
    //         (_, i) => i !== index
    //     )
    //     setInputFields(updatedFields)
    // }

    const handleFormSubmit = () => {
        const data = inputFields[0]
        const mappedConfig = checkMainValue()

        const configWithHierarchyId = mappedConfig.map(config => {
            if (config[hierarchyKeys.levelFive]) {
                const selectedItem = fetchOptions(hierarchyKeys.levelFive, 0).find(item => item.name === config[hierarchyKeys.levelFive]);
                if (selectedItem) {
                    return {
                        ...config,
                        HierarchyId: selectedItem.id
                    };
                }
            }
            return config;
        });

        const requestBody = {
            agent_group_name: data.agent_group_name?.trim(),
            config_key: data.config_key?.trim(),
            config_values: configWithHierarchyId,

        }

        const addRequestBody = {
            configKey: data.config_key?.trim(),
            action: data.action,
            groups:
                selectedGroups.length > 0
                    ? selectedGroups.map((group) => group.name?.trim())
                    : [data.agent_group_name?.trim()],
            configValues: configWithHierarchyId,
        }

        console.log("addRequestBody", addRequestBody)
        if (props.operation == "Add") {
            bulkGroupConfigUpdate(addRequestBody, props.userid)
                .then((res) => {
                    //console.log("responnnnse ", res)
                    notify(res.statusCode === 200 && res.response, "success")
                    notify(res.statusCode === 500 && res.response, "error")
                    props.setIsAddDialogOpen(false)
                    props.getAllLdapMethod()
                })
                .catch(async (error) => {
                    //console.log("error", error)
                    const value = await error
                    notify("Error in Adding Agent", "error")
                    //console.log("error", value)
                })
        } else if (props.operation == "Edit") {
            EditAgentGroupConfigRec(requestBody, props.userid)
                .then((res) => {
                    notify(res.statusCode === 200 && res.response, "success")
                    props.setIsAddDialogOpen(false)
                    props.getAllLdapMethod()
                })
                .catch(async (error) => {
                    const value = await error
                    notify("Error in Editing Agent", "error")
                    //console.log("error", value)
                })
        }
    }

    const handleAboveFeilds = (name, value) => {
        if (name === "config_key") {
            switch (value) {
                case "after_call_work":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "agent_states":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "allowed_conversation_media":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "business_attributes":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "crm":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "default_outbound_queue":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "queues_assigned":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "routing_profile_concurrency":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "proficiency":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "instance_config":
                    setMainArray([defaultDataFormats[value]])
                    break
                case "agent_hierarchy":
                    setMainArray([defaultDataFormats[value]])
                    break
                default:
                    const tempValue = [{ key: "", value: "" }]
                    setMainArray([tempValue])
            }
        }
        const updatedFields = [...inputFields]
        updatedFields[0][name] = value
        setInputFields(updatedFields)
    }

    const selectedObjectsForDelete = (index) => {
        setObjectSelected((prev) => {
            if (prev.has(index)) {
                prev.delete(index)
                return new Set([...Array.from(prev)])
            }
            return new Set([...Array.from(prev), index])
        })
    }

    const helperFunction = (name) => {
        const attributeNameObject = name.find(
            (obj) => obj.key === "attributeName"
        )?.value
        const newValue = convertArrayToInput(attributeList[attributeNameObject])
        return newValue
    }

    // console.log("queueList ==>>>>", queueList)

    const fetchOptions = (key, objIndex) => {
        let filteredOptions = [];
        const currentObj = mainArray[objIndex];
        
        switch(key) {
            case hierarchyKeys.levelOne:
                filteredOptions = agentGroupHierarchy.filter(item => item.level === "1");
                break;
                
            case hierarchyKeys.levelTwo:
                const selectedLevelOne = currentObj.find(item => item.key === hierarchyKeys.levelOne)?.value;
                if (selectedLevelOne) {
                    const levelOneItem = agentGroupHierarchy.find(item => item.name === selectedLevelOne);
                    filteredOptions = agentGroupHierarchy.filter(item => 
                        item.level === "2" && item.parentId === levelOneItem?.id
                    );
                }
                break;
                
            case hierarchyKeys.levelThree:
                const selectedLevelTwo = currentObj.find(item => item.key === hierarchyKeys.levelTwo)?.value;
                if (selectedLevelTwo) {
                    const levelTwoItem = agentGroupHierarchy.find(item => item.name === selectedLevelTwo);
                    filteredOptions = agentGroupHierarchy.filter(item => 
                        item.level === "3" && item.parentId === levelTwoItem?.id
                    );
                }
                break;
                
            case hierarchyKeys.levelFour:
                const selectedLevelThree = currentObj.find(item => item.key === hierarchyKeys.levelThree)?.value;
                if (selectedLevelThree) {
                    const levelThreeItem = agentGroupHierarchy.find(item => item.name === selectedLevelThree);
                    filteredOptions = agentGroupHierarchy.filter(item => 
                        item.level === "4" && item.parentId === levelThreeItem?.id
                    );
                }
                break;
                
            case hierarchyKeys.levelFive:
                const selectedLevelFour = currentObj.find(item => item.key === hierarchyKeys.levelFour)?.value;
                if (selectedLevelFour) {
                    const levelFourItem = agentGroupHierarchy.find(item => item.name === selectedLevelFour);
                    filteredOptions = agentGroupHierarchy.filter(item => 
                        item.level === "5" && item.parentId === levelFourItem?.id
                    );
                }
                break;
                
            default:
                filteredOptions = [];
        }
        
        return filteredOptions;
    }

    const renderView = (value) => {
        let view
        switch (value) {
            case "after_call_work":
                view = mainArray?.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj?.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>

                                                    <NumberField
                                                        width={"100%"}
                                                        isQuiet
                                                        isRequired
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        formatOptions={{
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0,
                                                        }}
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                value
                                                            )
                                                        }
                                                        necessityIndicator="label"
                                                        minValue={0}
                                                        defaultValue={0}
                                                    />
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "agent_states":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {mainArray[objIndex][
                                                        keyIndex
                                                    ].key === "routable" ? (
                                                        <Picker
                                                            width={"100%"}
                                                            items={[
                                                                {
                                                                    id: "true",
                                                                    name:
                                                                        "true",
                                                                },
                                                                {
                                                                    id: "false",
                                                                    name:
                                                                        "false",
                                                                },
                                                            ]}
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            defaultSelectedKey={
                                                                !props.editData
                                                                    ? "false"
                                                                    : mainArray[
                                                                          objIndex
                                                                      ][
                                                                          keyIndex
                                                                      ].value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </Picker>
                                                    ) : (
                                                        <Picker
                                                            width={"100%"}
                                                            items={statusList}
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            defaultSelectedKey={
                                                                !props.editData
                                                                    ? "Available"
                                                                    : mainArray[
                                                                          objIndex
                                                                      ][
                                                                          keyIndex
                                                                      ].value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </Picker>
                                                    )}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "allowed_conversation_media":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    <Picker
                                                        items={[
                                                            {
                                                                id: "true",
                                                                name: "true",
                                                            },
                                                            {
                                                                id: "false",
                                                                name: "false",
                                                            },
                                                        ]}
                                                        selectedKey={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        defaultSelectedKey={
                                                            !props.editData
                                                                ? "false"
                                                                : mainArray[
                                                                      objIndex
                                                                  ][keyIndex]
                                                                      .value
                                                        }
                                                        onSelectionChange={(
                                                            id
                                                        ) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                id
                                                            )
                                                        }
                                                    >
                                                        {(item) => (
                                                            <Item
                                                                key={item.name}
                                                            >
                                                                {item.name}
                                                            </Item>
                                                        )}
                                                    </Picker>
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "business_attributes":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {
                                                        <TextField
                                                            width={"100%"}
                                                            aria-label={
                                                                "value" +
                                                                keyIndex
                                                            }
                                                            key={
                                                                "value" +
                                                                keyIndex
                                                            }
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onChange={(value) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    value
                                                                )
                                                            }
                                                            isQuiet
                                                        />
                                                    }
                                                    {/* <View width={'20%'}>
                                        {(obj.length > 1) && <Button aria-label="addKeyValue" variant="secondary" staticColor="black" style="fill" onPress={()=>deleteKeyValuePair(objIndex, keyIndex)}><Delete/></Button>}
                                        {(obj.length - 1 == keyIndex) && <Button aria-label="addKeyValue" variant="secondary" staticColor="black" style="fill" onPress={()=>addNewKeyValuePair(objIndex)}><Add /></Button>}
                                        </View> */}
                                                    {/* </section>  */}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "crm":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    <Picker
                                                        width={"100%"}
                                                        items={[
                                                            {
                                                                id: "None",
                                                                name: "None",
                                                            },
                                                            {
                                                                id:
                                                                    "Enterprise",
                                                                name:
                                                                    "Enterprise",
                                                            },
                                                        ]}
                                                        selectedKey={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        defaultSelectedKey={
                                                            !props.editData
                                                                ? "Enterprise"
                                                                : mainArray[
                                                                      objIndex
                                                                  ][keyIndex]
                                                                      .value
                                                        }
                                                        onSelectionChange={(
                                                            id
                                                        ) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                id
                                                            )
                                                        }
                                                    >
                                                        {(item) => (
                                                            <Item
                                                                key={item.name}
                                                            >
                                                                {item.name}
                                                            </Item>
                                                        )}
                                                    </Picker>
                                                    {/* <TextField
                                                        width={"100%"}
                                                        aria-label={
                                                            "value" + keyIndex
                                                        }
                                                        key={"value" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                value
                                                            )
                                                        }
                                                        isQuiet
                                                    /> */}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "default_outbound_queue":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    <ComboBox
                                                        width={"100%"}
                                                        isQuiet
                                                        defaultItems={queueList}
                                                        selectedKey={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        defaultSelectedKey={
                                                            !props?.editData
                                                                ? queueList[0]
                                                                      ?.name
                                                                : mainArray[
                                                                      objIndex
                                                                  ][keyIndex]
                                                                      .value
                                                        }
                                                        onSelectionChange={(
                                                            id
                                                        ) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                id
                                                            )
                                                        }
                                                    >
                                                        {(item) => (
                                                            <Item
                                                                key={item.name}
                                                            >
                                                                {item.name}
                                                            </Item>
                                                        )}
                                                    </ComboBox>
                                                    {/* <TextField
                                                        width={"100%"}
                                                        aria-label={
                                                            "value" + keyIndex
                                                        }
                                                        key={"value" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].value
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                value
                                                            )
                                                        }
                                                        isQuiet
                                                    /> */}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "queues_assigned":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {mainArray[objIndex][
                                                        keyIndex
                                                    ].key === "queue_name" ? (
                                                        <ComboBox
                                                            isQuiet
                                                            width={"100%"}
                                                            defaultItems={
                                                                queueList
                                                            }
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            defaultSelectedKey={
                                                                !props.editData
                                                                    ? "chat"
                                                                    : mainArray[
                                                                          objIndex
                                                                      ][
                                                                          keyIndex
                                                                      ].value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id,
                                                                    "queues_assigned",
                                                                    obj
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </ComboBox>
                                                    ) : mainArray[objIndex][
                                                          keyIndex
                                                      ].key === "channel" ? (
                                                        <TextField
                                                            width={"100%"}
                                                            isQuiet
                                                            isReadOnly
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            // defaultSelectedKey={
                                                            //     mainArray[
                                                            //         objIndex
                                                            //     ][keyIndex]
                                                            //         .value
                                                            // }
                                                            // onSelectionChange={(
                                                            //     id
                                                            // ) =>
                                                            //     updateValue(
                                                            //         objIndex,
                                                            //         keyIndex,
                                                            //         "value",
                                                            //         id
                                                            //     )
                                                            // }
                                                        />
                                                    ) : (
                                                        <NumberField
                                                            width={"100%"}
                                                            isQuiet
                                                            isRequired
                                                            // isReadOnly
                                                            formatOptions={{
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            }}
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onChange={(value) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    value
                                                                )
                                                            }
                                                            necessityIndicator="label"
                                                            minValue={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .key ===
                                                                "delay"
                                                                    ? 0
                                                                    : 1
                                                            }
                                                            defaultValue={0}
                                                        />
                                                    )}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "routing_profile_concurrency":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {mainArray[objIndex][
                                                        keyIndex
                                                    ].key ===
                                                    "max_concurrency" ? (
                                                        <NumberField
                                                            width={"100%"}
                                                            isQuiet
                                                            isRequired
                                                            formatOptions={{
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            }}
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onChange={(value) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    value
                                                                )
                                                            }
                                                            necessityIndicator="label"
                                                            minValue={0}
                                                            defaultValue={0}
                                                        />
                                                    ) : mainArray[objIndex][
                                                          keyIndex
                                                      ].key ===
                                                      "cross_channel_allow" ? (
                                                        <Picker
                                                            width={"100%"}
                                                            items={[
                                                                {
                                                                    id: "true",
                                                                    name:
                                                                        "true",
                                                                },
                                                                {
                                                                    id: "false",
                                                                    name:
                                                                        "false",
                                                                },
                                                            ]}
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            defaultSelectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </Picker>
                                                    ) : (
                                                        <Picker
                                                            width={"100%"}
                                                            items={[
                                                                {
                                                                    id: "chat",
                                                                    name:
                                                                        "chat",
                                                                },
                                                                {
                                                                    id: "voice",
                                                                    name:
                                                                        "voice",
                                                                },
                                                                {
                                                                    id: "task",
                                                                    name:
                                                                        "task",
                                                                },
                                                                // {
                                                                //     id: "case",
                                                                //     name:
                                                                //         "case",
                                                                // },
                                                            ]}
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            defaultSelectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </Picker>
                                                    )}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "proficiency":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {mainArray[objIndex][
                                                        keyIndex
                                                    ].key === "level" ? (
                                                        <NumberField
                                                            width={"100%"}
                                                            isQuiet
                                                            isRequired
                                                            formatOptions={{
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 0,
                                                            }}
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onChange={(value) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    value
                                                                )
                                                            }
                                                            necessityIndicator="label"
                                                            minValue={1}
                                                            maxValue={5}
                                                            defaultValue={1}
                                                        />
                                                    ) : mainArray[objIndex][
                                                          keyIndex
                                                      ].key ===
                                                      "attributeName" ? (
                                                        <ComboBox
                                                            width={"100%"}
                                                            isQuiet
                                                            defaultItems={convertArrayToInput(
                                                                Object?.keys(
                                                                    attributeList
                                                                )
                                                            )}
                                                            selectedKey={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    .value
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id,
                                                                    "attributeName"
                                                                )
                                                            }
                                                        >
                                                            {(item) => (
                                                                <Item
                                                                    key={
                                                                        item.name
                                                                    }
                                                                >
                                                                    {item.name}
                                                                </Item>
                                                            )}
                                                        </ComboBox>
                                                    ) : mainArray[objIndex][
                                                          keyIndex
                                                      ].key ===
                                                      "attributeValue" ? (
                                                        <>
                                                            {/* <span>{helperFunction(mainArray[objIndex])}</span> */}
                                                            <ComboBox
                                                                width={"100%"}
                                                                isQuiet
                                                                defaultItems={helperFunction(
                                                                    mainArray[
                                                                        objIndex
                                                                    ]
                                                                )}
                                                                selectedKey={
                                                                    mainArray[
                                                                        objIndex
                                                                    ][keyIndex]
                                                                        ?.value
                                                                }
                                                                onSelectionChange={(
                                                                    id
                                                                ) =>
                                                                    updateValue(
                                                                        objIndex,
                                                                        keyIndex,
                                                                        "value",
                                                                        id
                                                                    )
                                                                }
                                                            >
                                                                {(item) => (
                                                                    <Item
                                                                        key={
                                                                            item.name
                                                                        }
                                                                    >
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </Item>
                                                                )}
                                                            </ComboBox>
                                                        </>
                                                    ) : null}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "instance_config":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"50%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ].key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    {mainArray[objIndex][
                                                        keyIndex
                                                    ].key ===
                                                    "instance_alias" ? (
                                                        <ComboBox
                                                            width={"100%"}
                                                            isQuiet
                                                            defaultItems={
                                                                instances || []
                                                            }
                                                            selectedKey={
                                                                instances?.filter(
                                                                    (
                                                                        instance
                                                                    ) =>
                                                                        instance.instance_id ===
                                                                            mainArray[
                                                                                objIndex
                                                                            ][
                                                                                keyIndex
                                                                            ]
                                                                                .value ||
                                                                        instance.instance_alias ===
                                                                            mainArray[
                                                                                objIndex
                                                                            ][
                                                                                keyIndex
                                                                            ]
                                                                                .value
                                                                )[0]
                                                                    ?.instance_id ||
                                                                ""
                                                            }
                                                            onSelectionChange={(
                                                                id
                                                            ) =>
                                                                updateValue(
                                                                    objIndex,
                                                                    keyIndex,
                                                                    "value",
                                                                    id,
                                                                    "instance_alias"
                                                                )
                                                            }
                                                        >
                                                            {(item) =>
                                                                console.log(
                                                                    "item",
                                                                    item
                                                                ) || (
                                                                    <Item
                                                                        key={
                                                                            item.instance_id
                                                                        }
                                                                    >
                                                                        {
                                                                            item.instance_alias
                                                                        }
                                                                    </Item>
                                                                )
                                                            }
                                                        </ComboBox>
                                                    ) : (
                                                        <TextField
                                                            width={"100%"}
                                                            aria-label={
                                                                "value" +
                                                                keyIndex
                                                            }
                                                            key={
                                                                "value" +
                                                                keyIndex
                                                            }
                                                            value={
                                                                mainArray[
                                                                    objIndex
                                                                ][keyIndex]
                                                                    ?.value
                                                            }
                                                            isReadOnly
                                                            // onChange={(value) =>
                                                            //     updateValue(
                                                            //         objIndex,
                                                            //         keyIndex,
                                                            //         "value",
                                                            //         value
                                                            //     )
                                                            // }
                                                            isQuiet
                                                        />
                                                    )}
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
                break
            case "agent_hierarchy":
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                    
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"100%"}
                                                        aria-label={"key" + keyIndex}
                                                        key={"key" + keyIndex}
                                                        value={mainArray[objIndex][keyIndex].key}
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value,
                                                                
                                                            )
                                                        }
                                                        isDisabled={true}
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    <Picker
                                                        width={"100%"}
                                                        placeholder="Select"
                                                        items={fetchOptions(mainArray[objIndex][keyIndex].key, objIndex) || []}
                                                        selectedKey={mainArray[objIndex][keyIndex].value}
                                                        onSelectionChange={(id) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                id,
                                                                "agent_hierarchy"
                                                            )
                                                        }
                                                    >
                                                        {(item) => (
                                                            <Item key={item.name}>
                                                                {item.name}
                                                            </Item>
                                                        )}
                                                    </Picker>
                                                </Flex>
                                            </View>
                                        );
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    isDisabled={inputFields[0]?.config_key === "agent_hierarchy" && mainArray.length === 1}
                                    UNSAFE_style={inputFields[0]?.config_key === "agent_hierarchy" && mainArray.length === 1 && {cursor: "not-allowed"}}
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    );
                });
                break;
            default:
                view = mainArray.map((obj, objIndex) => {
                    return (
                        <div
                            key={objIndex}
                            className={
                                objectSelected.has(objIndex)
                                    ? "cardSection active"
                                    : "cardSection"
                            }
                        >
                            <section className="checkboxSection">
                                <Checkbox
                                    aria-label="selectObject"
                                    isSelected={objectSelected.has(objIndex)}
                                    onChange={() =>
                                        selectedObjectsForDelete(objIndex)
                                    }
                                ></Checkbox>
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="FormSection">
                                {obj.length >= 1 &&
                                    obj.map((_keyVal, keyIndex) => {
                                        return (
                                            <View
                                                key={keyIndex}
                                                UNSAFE_className="feild"
                                            >
                                                <Flex gap={"size-100"}>
                                                    <TextField
                                                        width={"100%"}
                                                        aria-label={
                                                            "key" + keyIndex
                                                        }
                                                        key={"key" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ]?.key
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "key",
                                                                value
                                                            )
                                                        }
                                                        isQuiet
                                                    />
                                                    <strong>:</strong>
                                                    <TextField
                                                        width={"100%"}
                                                        aria-label={
                                                            "value" + keyIndex
                                                        }
                                                        key={"value" + keyIndex}
                                                        value={
                                                            mainArray[objIndex][
                                                                keyIndex
                                                            ]?.value
                                                        }
                                                        onChange={(value) =>
                                                            updateValue(
                                                                objIndex,
                                                                keyIndex,
                                                                "value",
                                                                value
                                                            )
                                                        }
                                                        isQuiet
                                                    />
                                                    <Flex width={"50%"}>
                                                        {obj.length > 1 && (
                                                            <Button
                                                                aria-label="addKeyValue"
                                                                variant="secondary"
                                                                staticColor="black"
                                                                style="fill"
                                                                onPress={() =>
                                                                    deleteKeyValuePair(
                                                                        objIndex,
                                                                        keyIndex
                                                                    )
                                                                }
                                                            >
                                                                <Delete />
                                                            </Button>
                                                        )}
                                                        {obj.length - 1 ==
                                                            keyIndex && (
                                                            <Button
                                                                aria-label="addKeyValue"
                                                                variant="secondary"
                                                                staticColor="black"
                                                                style="fill"
                                                                onPress={() =>
                                                                    addNewKeyValuePair(
                                                                        objIndex
                                                                    )
                                                                }
                                                            >
                                                                <Add />
                                                            </Button>
                                                        )}
                                                    </Flex>
                                                </Flex>
                                            </View>
                                        )
                                    })}
                            </section>
                            <Divider size="S" orientation="vertical" />
                            <section className="actionsSection">
                                <Button
                                    aria-label="Clone Object"
                                    variant="secondary"
                                    staticColor="black"
                                    style="fill"
                                    onPress={() => cloneObject(objIndex, obj)}
                                >
                                    <Copy />
                                </Button>
                            </section>
                        </div>
                    )
                })
        }
        return view
    }

    // const handleFormChange = (inputName, event, index) => {
    //     const value = event
    //     const updatedFields = [...inputFields]
    //     updatedFields[0].config_values[index][inputName] = value
    //     setInputFields(updatedFields)
    // }

    // const performAction = (value, index) => {
    //     switch (value) {
    //         case "add":
    //             addFields()
    //             // editData.current = null;
    //             // setIsAddDialogOpen(true);
    //             // setOperation("Add")
    //             break
    //         case "edit":
    //             // editData.current =  allContacts.find((d) => (d.ruleId == contactNumber));
    //             // setIsAddDialogOpen(true);
    //             // setOperation("Edit")
    //             break
    //         case "delete":
    //             deleteFields(index)
    //             // currentContactSelected.current = `${contactNumber}`;
    //             // setIsDeleteDialogOpen(true);
    //             break
    //         case "bulkDelete":
    //             // setIsDeleteDialogOpen(true);
    //             break
    //     }
    // }

    const deleteSelectedObjects = () => {
        const arrayofIndexes = Array.from(objectSelected)
        const data = JSON.parse(JSON.stringify(mainArray)).filter(
            (obj, index) => !arrayofIndexes.includes(index)
        )
        setMainArray(() => [...data])
        setObjectSelected(new Set([]))
    }

    // const resetGroupForm = () => {
    //     if (props.editData) {
    //         props.editData.config_values
    //             .map((entry) => {
    //                 const keyValues = Object.entries(entry)
    //                 return keyValues.map(([key, value]) => ({ key, value }))
    //             })
    //             .flat()
    //         const mappedData = props.editData.config_values.map((entry) => {
    //             const keyValues = Object.entries(entry)
    //             return keyValues.map(([key, value]) => ({ key, value }))
    //         })
    //         setMainArray([...mappedData])
    //     } else {
    //         setMainArray([sideArray])
    //     }
    // }

    // useEffect(() => {
    //     console.log({ activeInstance })
    // }, [activeInstance])

    // group name and action
    useEffect(() => {
        if (props.groupNameList && props.groupNameList.length > 0) {
            const normalizedGroups = props.groupNameList.map((group, index) => {
                const uniqueId =
                    typeof group === "string"
                        ? `group-${index}-${group}`
                        : group.id || `group-${index}`

                return typeof group === "string"
                    ? { id: uniqueId, name: group, selected: false }
                    : {
                          ...group,
                          id: uniqueId,
                          selected: group.selected || false,
                      }
            })

            // console.log("Normalized groups:", normalizedGroups)
            setLocalGroupList(normalizedGroups)
        }
    }, [props.groupNameList])


    const filteredGroups = searchQuery
        ? localGroupList.filter((group) =>
              group.name.toLowerCase().includes(searchQuery.toLowerCase())
          )
        : localGroupList

    const selectedGroups = localGroupList.filter((group) => group.selected)
    const selectedCount = selectedGroups.length

    const handleSelectAll = useCallback((checked) => {
        setLocalGroupList((prevGroups) =>
            prevGroups.map((group) => ({
                ...group,
                selected: checked,
            }))
        )
    }, [])

    const handleGroupSelect = useCallback((selectedGroupId) => {
        // console.log("Toggling selection for group ID:", selectedGroupId)
        setLocalGroupList((prevGroups) => {
            const updatedGroups = prevGroups.map((group) => {
                const shouldToggle = group.id === selectedGroupId
                return shouldToggle
                    ? { ...group, selected: !group.selected }
                    : group
            })
            // console.log("Updated groups after toggle:", updatedGroups)
            return updatedGroups
        })
    }, [])

    const isValid = React.useMemo(() => {
        const hasValidGroupName =
            inputFields[0]?.agent_group_name?.trim() !== "" ||
            selectedGroups.length > 0
        const hasValidConfigKey =
            inputFields[0]?.config_key?.length > 0 &&
            inputFields[0]?.config_key?.trim() !== ""
        const hasValidConfigValues =
            mainArray.length > 0 &&
            mainArray.every(
                (obj) =>
                    obj.length > 0 &&
                    obj.every(
                        (item) =>
                            item.key?.trim() !== "" &&
                            item.value?.toString().trim() !== ""
                    )
            )
        return hasValidGroupName && hasValidConfigKey && hasValidConfigValues
    }, [inputFields, selectedGroups, mainArray])

    console.log("inputFields[0]?.config_key", inputFields[0]?.config_key)

    return (
        <DialogTrigger
            type="modal"
            mobileType="modal"
            isOpen={props.isDialogOpened}
            defaultOpen={false}
        >
            <ActionButton isHidden isQuiet></ActionButton>
            <Dialog
                size="L"
                width={props.operation == "Add" ? "1100px" : "772px"}
                height={props.operation == "Add" ? "700px" : null}
            >
                <Heading>Agent Group Config</Heading>
                <Divider />
                <Content>
                    {props.operation == "Add" ? (
                        <Flex direction={"row"} gap={"size-300"}>
                            <View
                                borderWidth="thin"
                                borderColor="gray-300"
                                borderRadius="medium"
                                padding="size-300"
                                paddingTop={0}
                                width="size-4600"
                                overflow="auto"
                                minHeight="size-6000"
                                maxHeight="size-6000"
                                position={"sticky"}
                                top={0}
                            >
                                <View>
                                    <Heading level={5}>Select groups</Heading>
                                    <SearchField
                                        value={searchQuery}
                                        onChange={setSearchQuery}
                                        placeholder="Search groups"
                                        marginBottom="size-200"
                                        UNSAFE_style={{ width: "100%" }}
                                    />
                                </View>
                                <Flex
                                    direction="row"
                                    gap="size-100"
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <Checkbox
                                        isSelected={
                                            selectedCount ===
                                                localGroupList.length &&
                                            localGroupList.length > 0
                                        }
                                        onChange={handleSelectAll}
                                        isDisabled={
                                            inputFields[0]?.agent_group_name
                                        }
                                    >
                                        Select all
                                    </Checkbox>
                                    <Text>
                                        Total groups selected: {selectedCount}
                                    </Text>
                                </Flex>

                                {filteredGroups.length > 0 ? (
                                    filteredGroups.map((group) => (
                                        <View>
                                            <Checkbox
                                                key={group.id}
                                                value={group.name}
                                                isSelected={group.selected}
                                                onChange={() =>
                                                    handleGroupSelect(group.id)
                                                }
                                                isDisabled={
                                                    inputFields[0]
                                                        ?.agent_group_name
                                                }
                                            >
                                                {group.name}
                                            </Checkbox>
                                        </View>
                                    ))
                                ) : (
                                    <View>
                                        <Heading level={5}>
                                            Fetching groups...
                                        </Heading>
                                    </View>
                                )}
                            </View>
                            <View>
                                <Flex direction={"row"} gap={"size-100"}>
                                    <TextField
                                        label="Agent Group Name"
                                        name="agent_group_name"
                                        placeholder="create new group"
                                        value={inputFields[0]?.agent_group_name}
                                        onChange={(value) => {
                                            const valueWithNoSpace = value.replace(
                                                /\s/g,
                                                ""
                                            )
                                            handleAboveFeilds(
                                                "agent_group_name",
                                                valueWithNoSpace
                                            )
                                            // handleAboveFeilds("agent_group_name", value)
                                        }}
                                        isDisabled={
                                            props.operation == "Edit" ||
                                            selectedGroups.length > 0
                                        }
                                    />
                                    <ComboBox
                                        label="Config Key"
                                        value={inputFields[0]?.config_key}
                                        onInputChange={(value) => {
                                            const valueWithNoSpace = value.replace(
                                                /\s/g,
                                                ""
                                            )
                                            handleAboveFeilds(
                                                "config_key",
                                                valueWithNoSpace
                                            )
                                        }}
                                        allowsCustomValue
                                        isDisabled={
                                            (props.operation == "Edit" &&
                                            !props.editData?.group_name) ||
                                           ( !inputFields[0]?.agent_group_name && 
                                            selectedGroups.length === 0
                                           )
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === " ") {
                                                e.preventDefault()
                                            }
                                        }}
                                    >
                                        {configKeys
                                            .sort((a, b) =>
                                                a.key.localeCompare(b.key)
                                            )
                                            .map((config) => (
                                                <Item key={config.key}>
                                                    {config.key}
                                                </Item>
                                            ))}
                                    </ComboBox>

                                    <ComboBox
                                        label="Action"
                                        name="action"
                                        // defaultItems={actionItems}
                                        selectedKey={inputFields[0]?.action}
                                        onSelectionChange={(value) => {
                                            handleAboveFeilds("action", value)
                                        }}
                                    >
                                        <Item key="add">Add / Update</Item>
                                        <Item
                                            key="remove"
                                            isDisabled={
                                                inputFields[0]?.agent_group_name
                                            }
                                        >
                                            Remove
                                        </Item>
                                        <Item
                                            key="sync"
                                            isDisabled={
                                                inputFields[0]?.agent_group_name
                                            }
                                        >
                                            Sync (override)
                                        </Item>
                                    </ComboBox>
                                </Flex>
                                <Well
                                    marginY="size-200"
                                    UNSAFE_style={{ overflow: "auto" }}
                                >
                                    <Heading level={5} marginBottom="size-100">
                                        Selected groups to update
                                    </Heading>
                                    <Content marginTop="size-100">
                                        {selectedCount === 0 ? (
                                            <Text>
                                                No group is selected to update.
                                                Please select the group(s) from
                                                the left panel.
                                            </Text>
                                        ) : (
                                            <View>
                                                <Flex
                                                    direction="row"
                                                    wrap
                                                    gap="size-75"
                                                    maxHeight="size-1600"
                                                    maxWidth="600px"
                                                    overflow="auto"
                                                    borderWidth="thin"
                                                    borderColor="gray-300"
                                                    borderRadius="small"
                                                    padding="size-100"
                                                >
                                                    {selectedGroups.map(
                                                        (group) => (
                                                            <View
                                                                key={group.id}
                                                                backgroundColor="gray-400"
                                                                paddingStart="size-100"
                                                                // paddingY="size-50"
                                                                borderRadius="medium"
                                                                // marginBottom="size-50"
                                                                UNSAFE_style={{
                                                                    display:
                                                                        "inline-flex",
                                                                    alignItems:
                                                                        "center",
                                                                    color:
                                                                        "#222222",
                                                                    gap: "8px",
                                                                }}
                                                            >
                                                                <Flex
                                                                    direction="row"
                                                                    alignItems="center"
                                                                    gap="size-50"
                                                                >
                                                                    <Text
                                                                        color="white"
                                                                        UNSAFE_style={{
                                                                            fontSize:
                                                                                "12px",
                                                                            fontWeight: 400,
                                                                        }}
                                                                    >
                                                                        {
                                                                            group.name
                                                                        }
                                                                    </Text>
                                                                    <ActionButton
                                                                        isQuiet
                                                                        onPress={() =>
                                                                            handleGroupSelect(
                                                                                group.id
                                                                            )
                                                                        }
                                                                        UNSAFE_style={{
                                                                            backgroundColor:
                                                                                "transparent",
                                                                            border:
                                                                                "none",
                                                                            cursor:
                                                                                "pointer",
                                                                        }}
                                                                    >
                                                                        ✕
                                                                    </ActionButton>
                                                                </Flex>
                                                            </View>
                                                        )
                                                    )}
                                                </Flex>
                                            </View>
                                        )}
                                    </Content>
                                </Well>
                                <Divider size="S" marginY={10} />
                                <View>
                                    <Flex
                                        direction={"row"}
                                        justifyContent={"space-between"}
                                    >
                                        <View>
                                            <Header>
                                                <strong>Config Value</strong>
                                            </Header>
                                        </View>
                                        <View>
                                            <ButtonGroup UNSAFE_className="noBorder">
                                                <Button
                                                    aria-label="AddObject"
                                                    variant="secondary"
                                                    staticColor="black"
                                                    style="fill"
                                                    isDisabled={inputFields[0]?.config_key === "agent_hierarchy" && mainArray.length === 1}
                                                    UNSAFE_style={inputFields[0]?.config_key === "agent_hierarchy" && mainArray.length === 1 && {cursor: "not-allowed"}}
                                                    onPress={() =>
                                                        addNewobject(
                                                            "config_key",
                                                            inputFields[0]
                                                                ?.config_key
                                                        )
                                                    }
                                                >
                                                    <Add />
                                                </Button>
                                                <Button
                                                    aria-label="DeleteSelectedObjects"
                                                    variant="secondary"
                                                    staticColor="black"
                                                    style="fill"
                                                    onPress={() =>
                                                        deleteSelectedObjects()
                                                    }
                                                    isDisabled={
                                                        !objectSelected.size
                                                    }
                                                >
                                                    <Delete />
                                                </Button>
                                                {/* <Button
                                                    aria-label="ResetGroupValue"
                                                    variant="secondary"
                                                    staticColor="black"
                                                    style="fill"
                                                    onPress={() =>
                                                        resetGroupForm()
                                                    }
                                                >
                                                    <Undo />
                                                </Button> */}
                                            </ButtonGroup>
                                        </View>
                                    </Flex>
                                    <Flex
                                        direction={"column"}
                                        justifyContent={"center"}
                                        gap={"size-100"}
                                        marginTop={"size-100"}
                                    >
                                        {renderView(
                                            inputFields[0].config_key?.trim()
                                        )}
                                    </Flex>
                                </View>
                            </View>
                        </Flex>
                    ) : (
                        <>
                            <Flex direction={"row"} gap={"size-300"}>
                                <TextField
                                    label="Agent Group Name"
                                    name="agent_group_name"
                                    value={inputFields[0]?.agent_group_name}
                                    onChange={(value) => {
                                        const valueWithNoSpace = value.replace(
                                            /\s/g,
                                            ""
                                        )
                                        handleAboveFeilds(
                                            "agent_group_name",
                                            valueWithNoSpace
                                        )
                                        // handleAboveFeilds("agent_group_name", value)
                                    }}
                                    isDisabled={props.operation == "Edit"}
                                />

                                <ComboBox
                                    label="Config Key"
                                    selectedKey={inputFields[0]?.config_key}
                                    onSelectionChange={(value) => {
                                        handleAboveFeilds("config_key", value)
                                    }}
                                    allowsCustomValue
                                    isDisabled={
                                        props.operation == "Edit" &&
                                        !props.editData?.group_name
                                    }
                                >
                                     {configKeys
                                            .sort((a, b) =>
                                                a.key.localeCompare(b.key)
                                            )
                                            .map((config) => (
                                                <Item key={config.key}>
                                                    {config.key}
                                                </Item>
                                            ))}
                                    {/* {!configKeys.includes(
                                        inputFields[0]?.config_key
                                    ) &&
                                        inputFields[0]?.config_key && (
                                            <Item
                                                key={inputFields[0]?.config_key}
                                            >
                                                {inputFields[0]?.config_key}
                                            </Item>
                                        )} */}
                                </ComboBox>
                            </Flex>
                            <Divider size="S" marginY={10} />
                            <View>
                                <Flex
                                    direction={"row"}
                                    justifyContent={"space-between"}
                                >
                                    <View>
                                        <Header>
                                            <strong>Config Value</strong>
                                        </Header>
                                    </View>
                                    <View>
                                        <ButtonGroup UNSAFE_className="noBorder">
                                            <Button
                                                aria-label="AddObject"
                                                variant="secondary"
                                                staticColor="black"
                                                style="fill"
                                                onPress={() =>
                                                    addNewobject(
                                                        "config_key",
                                                        inputFields[0]
                                                            ?.config_key
                                                    )
                                                }
                                            >
                                                <Add />
                                            </Button>
                                            <Button
                                                aria-label="DeleteSelectedObjects"
                                                variant="secondary"
                                                staticColor="black"
                                                style="fill"
                                                onPress={() =>
                                                    deleteSelectedObjects()
                                                }
                                                isDisabled={
                                                    !objectSelected.size
                                                }
                                            >
                                                <Delete />
                                            </Button>
                                            {/* <Button
                                                aria-label="ResetGroupValue"
                                                variant="secondary"
                                                staticColor="black"
                                                style="fill"
                                                onPress={() => resetGroupForm()}
                                            >
                                                <Undo />
                                            </Button> */}
                                        </ButtonGroup>
                                    </View>
                                </Flex>
                                <Flex
                                    direction={"column"}
                                    justifyContent={"center"}
                                    gap={"size-100"}
                                    marginTop={"size-100"}
                                >
                                    {renderView(
                                        inputFields[0].config_key?.trim()
                                    )}
                                </Flex>
                            </View>
                        </>
                    )}
                </Content>
                <Footer>
                    <Flex>
                        <View>
                            <ButtonGroup>
                                <Button
                                    variant="secondary"
                                    onPress={() =>
                                        props.setIsAddDialogOpen(false)
                                    }
                                >
                                    Cancel
                                </Button>
                                <Button
                                    variant="primary"
                                    onPress={handleFormSubmit}
                                    isDisabled={isValid ? false : true}
                                >
                                    Submit
                                </Button>
                            </ButtonGroup>
                        </View>
                    </Flex>
                </Footer>
            </Dialog>
        </DialogTrigger>
    )
}

export default DynamicFieldForm
